var Address = require('../models/address'),
	Authorization = require('../models/authorization'),
	AuthorizationProcessor = require('../models/authorizationProcessor'),
	CCAExtension = require('../models/payments/ccaExtension'),
	Consumer = require('../models/consumer'),
	MidasResponse = require('../models/midasResponse'),
	Payment = require('../models/payment'),
	Risk = require('../models/risk'),
	Token = require('../models/token');

var publicMethods = {
	map: {
		midas: {
			to: {
				address: function (responseData) {
					if (responseData) {
						return new Address(responseData.FirstName, responseData.MiddleName, responseData.LastName, responseData.FullName, responseData.Address1, responseData.Address2, responseData.Address3, responseData.City, responseData.State, responseData.PostalCode, responseData.CountryCode, responseData.Phone1, responseData.Phone2);
					}

					return;
				},
				authorization: function (responseData) {
					if (responseData) {
						return new Authorization(responseData.AuthorizeAccount, responseData.Status);
					}

					return;
				},
				authorizationProcessor: function (responseData) {
					if (responseData) {
						return new AuthorizationProcessor(responseData.ProcessorOrderId, responseData.ProcessorTransactionId, responseData.ReasonCode, responseData.ReasonDescription);
					}

					return;
				},
				consumer: function (responseData) {
					if (responseData) {
						return new Consumer(responseData.Email1, responseData.Email2, publicMethods.map.to.address(responseData.BillingAddress), publicMethods.map.to.address(responseData.ShippingAddress), responseData.Account);
					}

					return;
				},
				payment: function (responseData) {
					if (responseData) {
						return new Payment(responseData.Type, responseData.ReasonCode, responseData.ReasonDescription, responseData.ProcessorTransactionId, responseData.OrderId, responseData.OrderNumber, responseData.ExtendedData, publicMethods.map.midas.to.address(responseData.BillingAddress), publicMethods.map.midas.to.address(responseData.ShippingAddress));
					}

					return;
				},
				risk: function (responseData) {
					if (responseData) {
						return new Risk(responseData.ReasonCode, responseData.ReasonDescription);
					}

					return;
				},
				token: function (responseData) {
					if (responseData) {
						return new Token(responseData.Token, responseData.ExpirationMonth, responseData.ExpirationYear, responseData.AuthorizeStatus, responseData.ReasonCode, responseData.ReasonDescription);
					}

					return;
				},
				merchantResponse: function (responseData) {
					if (responseData) {
						return new MidasResponse(responseData.Validated, responseData.ErrorNumber, responseData.ErrorDescription, responseData.ActionCode, responseData.JWE,
								publicMethods.map.midas.to.payment(responseData.Payment), publicMethods.map.midas.to.consumer(responseData.Consumer), 
								publicMethods.map.midas.to.token(responseData.Token), publicMethods.map.midas.to.authorizationProcessor(responseData.AuthorizationProcessor),publicMethods.map.midas.to.authorization(responseData.Authorization), 
								publicMethods.map.midas.to.risk(responseData.Risk));
					}

					return {};
				},
				paymentExtension: {
					ccaExtendedData: function (responseData) {
						if (responseData) {
							return new CCAExtension(responseData.CAVV, responseData.ECIFlag, responseData.PAResStatus, responseData.SignatureVerification);
						}

						return {};
					}
				}
			}
		},
		payment: {
			from : {
				cca: function(ccaObject){
					var extendedData;
					
					if(ccaObject.Enrolled){
						extendedData = {
							Enrolled: ccaObject.Enrolled 
						};
					} else {
						extendedData = publicMethods.map.midas.to.paymentExtension.ccaExtendedData(ccaObject);
					}
					
					return new Payment('cca', ccaObject.ReasonCode, ccaObject.ReasonDescription, ccaObject.TransactionId, extendedData);
				}
			}
		}
	}
};

module.exports = publicMethods;


//////////////////
// WEBPACK FOOTER
// ./utilities/responseMapper.js
// module id = 39
// module chunks = 0 5 20